import React, { useContext, useMemo } from 'react';
import { ConfirmProvider } from 'material-ui-confirm';
import { createTheme, ThemeProvider } from '@mui/material';
import { deDE } from '@mui/material/locale';
import { observer } from 'mobx-react';
import Router from './Router';
import layoutStore, { LayoutContext } from './stores/LayoutStore';
import themeStore, { ThemeContext } from './stores/ThemeStore';
import Footer from './components/Footer';

function AppContent() {
  const activeThemeStore = useContext(ThemeContext);
  const theme = useMemo(() => createTheme({
    cssVariables: true,
    palette: {
      white: { main: '#FFFFFF' },
    },
    typography: {
      ...activeThemeStore.typography,
    },
  }, deDE), [activeThemeStore.typography]);

  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <Router />
        <Footer />
      </ConfirmProvider>
    </ThemeProvider>
  );
}

const ObservedAppContent = observer(AppContent);

function App() {
  return (
    <LayoutContext.Provider value={layoutStore}>
      <ThemeContext.Provider value={themeStore}>
        <ObservedAppContent />
      </ThemeContext.Provider>
    </LayoutContext.Provider>
  );
}

export default observer(App);
